import { useContext, useMemo } from "react";

import { useSearchParams } from "react-router";

import { ResponseContext } from "@/components/ResponseContext";

function getWorkspaceSlug(host?: string): string | undefined {
  if (!host) return undefined;

  if (!WEB_APP.endsWith(host)) {
    return host.split(".")[0];
  }

  return undefined;
}

/**
 * Returns the workspace slug from the current host subdomain.
 *
 * @deprecated
 *
 * This is only meant to be used on the following public pages:
 *
 * - /login
 * - /forgot-password
 * - /reset-password
 * - /confirm-email
 * - /activate-membership
 * - /set-password
 *
 * Don't use it in other places because we might eventually deprecate
 * subdomains.
 *
 * @returns The workspace slug from subdomain, or undefined if not in a workspace subdomain
 */
export function useWorkspaceSlug(): string | undefined {
  const context = useContext(ResponseContext);
  const [searchParams] = useSearchParams();

  if (!context) {
    throw new Error(
      "useWorkspaceSlug must be used within a ResponseContextProvider",
    );
  }

  return useMemo(() => {
    const workspaceSlug = searchParams.get("workspace");
    if (workspaceSlug && workspaceSlug !== "None") return workspaceSlug;

    const host =
      typeof window === "undefined"
        ? context.req?.headers?.host || ""
        : window.location.host;

    return getWorkspaceSlug(host);
  }, []); // Empty deps since we only need to calculate this once
}
